module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qback2-4a24a57d6cec3994e64fb9aed616f63a.jpg";